import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { QuizSession } from './saveQuizSession';

export async function submitQuizSession(
   quizid: number,
   quiz_revisionid: number,
   response_json: string,
   langid: string,
   { ...common }: CommonRequestOptions = {}
): Promise<QuizSession> {
   return makeRequest('post', '/quizzes/sessions/submit', {
      ...common,
      body: {
         quizid,
         quiz_revisionid,
         response_json,
         langid,
      },
   });
}
